import {
  createPickupLocation as publicCreatePickupLocation,
  getPickupLocation as publicGetPickupLocation,
  updatePickupLocation as publicUpdatePickupLocation,
  deletePickupLocation as publicDeletePickupLocation,
  queryPickupLocation as publicQueryPickupLocation,
  addDeliveryRegion as publicAddDeliveryRegion,
  removeDeliveryRegion as publicRemoveDeliveryRegion,
  bulkCreatePickupLocation as publicBulkCreatePickupLocation,
  bulkUpdatePickupLocation as publicBulkUpdatePickupLocation,
  bulkDeletePickupLocation as publicBulkDeletePickupLocation,
} from './ecom-v1-pickup-location-pickup-locations.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createPickupLocation: MaybeContext<
  BuildRESTFunction<typeof publicCreatePickupLocation> &
    typeof publicCreatePickupLocation
> = /*#__PURE__*/ createRESTModule(publicCreatePickupLocation);
export const getPickupLocation: MaybeContext<
  BuildRESTFunction<typeof publicGetPickupLocation> &
    typeof publicGetPickupLocation
> = /*#__PURE__*/ createRESTModule(publicGetPickupLocation);
export const updatePickupLocation: MaybeContext<
  BuildRESTFunction<typeof publicUpdatePickupLocation> &
    typeof publicUpdatePickupLocation
> = /*#__PURE__*/ createRESTModule(publicUpdatePickupLocation);
export const deletePickupLocation: MaybeContext<
  BuildRESTFunction<typeof publicDeletePickupLocation> &
    typeof publicDeletePickupLocation
> = /*#__PURE__*/ createRESTModule(publicDeletePickupLocation);
export const queryPickupLocation: MaybeContext<
  BuildRESTFunction<typeof publicQueryPickupLocation> &
    typeof publicQueryPickupLocation
> = /*#__PURE__*/ createRESTModule(publicQueryPickupLocation);
export const addDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicAddDeliveryRegion> &
    typeof publicAddDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicAddDeliveryRegion);
export const removeDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicRemoveDeliveryRegion> &
    typeof publicRemoveDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicRemoveDeliveryRegion);
export const bulkCreatePickupLocation: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreatePickupLocation> &
    typeof publicBulkCreatePickupLocation
> = /*#__PURE__*/ createRESTModule(publicBulkCreatePickupLocation);
export const bulkUpdatePickupLocation: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdatePickupLocation> &
    typeof publicBulkUpdatePickupLocation
> = /*#__PURE__*/ createRESTModule(publicBulkUpdatePickupLocation);
export const bulkDeletePickupLocation: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeletePickupLocation> &
    typeof publicBulkDeletePickupLocation
> = /*#__PURE__*/ createRESTModule(publicBulkDeletePickupLocation);

export {
  ConditionType,
  LogicalOperator,
  SortOrder,
  WebhookIdentityType,
} from './ecom-v1-pickup-location-pickup-locations.universal.js';
export {
  PickupLocation,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  ConditionalRates,
  Condition,
  DiffmatokyPayload,
  ErrorInformation,
  CreatePickupLocationRequest,
  CreatePickupLocationResponse,
  GetPickupLocationRequest,
  GetPickupLocationResponse,
  UpdatePickupLocationRequest,
  UpdatePickupLocationResponse,
  DeletePickupLocationRequest,
  DeletePickupLocationResponse,
  QueryPickupLocationRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryPickupLocationResponse,
  CursorPagingMetadata,
  Cursors,
  AddDeliveryRegionRequest,
  AddDeliveryRegionResponse,
  RemoveDeliveryRegionRequest,
  RemoveDeliveryRegionResponse,
  BulkCreatePickupLocationRequest,
  BulkCreatePickupLocationResponse,
  PickupLocationError,
  ApplicationError,
  BulkUpdatePickupLocationRequest,
  BulkUpdatePickupLocationResponse,
  BulkDeletePickupLocationRequest,
  BulkDeletePickupLocationResponse,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  PickupLocationNonNullableFields,
  CreatePickupLocationResponseNonNullableFields,
  GetPickupLocationResponseNonNullableFields,
  UpdatePickupLocationResponseNonNullableFields,
  QueryPickupLocationResponseNonNullableFields,
  AddDeliveryRegionResponseNonNullableFields,
  RemoveDeliveryRegionResponseNonNullableFields,
  BulkCreatePickupLocationResponseNonNullableFields,
  BulkUpdatePickupLocationResponseNonNullableFields,
  BulkDeletePickupLocationResponseNonNullableFields,
  UpdatePickupLocation,
  PickupLocationsQueryResult,
  PickupLocationsQueryBuilder,
  AddDeliveryRegionOptions,
  RemoveDeliveryRegionOptions,
} from './ecom-v1-pickup-location-pickup-locations.universal.js';
